import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

export function usePlanRoot() {
    const { parentItem } = useBoundContext()
    return parentFind(parentItem, (c) => c[PlanRoot])
}
